<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" style="position:relative; margin-top: -60px">
                <v-row>
                    <v-col>
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-group</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total Registrados</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ referreds.length }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col>
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total pago mensual</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">${{ monthly_payment }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col>
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-group</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Referidos del día</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ referreds_today }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" lg="7" md="6" sm="12">
                        <v-card>
                            <v-card-title>Mis pagos</v-card-title>
                            <v-card-text>
                                <v-simple-table v-if="payments.length > 0">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(payment, index) in payments" :key="index">
                                                <td>{{ payment.date }}</td>
                                                <td>{{ payment.quantity }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <p v-else class="mb-0 text-center">Sin pagos registrados</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="5" md="6" sm="12">
                        <v-card>
                            <v-card-title>
                                <v-icon left>mdi-credit-card</v-icon>
                                Datos de pago
                            </v-card-title>
                            <v-card-text v-if="partnership.billing_information">
                                <v-card outlined>
                                    <v-card-text>
                                        <p class="my-2">N° Tarjeta : {{ partnership.billing_information.account }}</p>
                                        <v-divider></v-divider>
                                        <p class="my-2">Nombre(s) : {{ partnership.billing_information.names }}</p>
                                        <v-divider></v-divider>
                                        <p class="my-2">Banco : {{ partnership.billing_information.bank }}</p>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                            <v-card-text class="text-center" v-else>
                                <p class="mb-0">Sin datos registrados, añada una tarjeta de débito.</p>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions class="px-0 py-0">
                                <v-btn href="/payments" block text v-if="partnership.billing_information">Modificar</v-btn>
                                <v-btn href="/payments" block text v-else>Añadir</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    props:['partnership','referreds','referreds_today','payments'],
    data:() => ({

    }),

    computed:{
        monthly_payment:function(){
            let total = this.partnership.agreement * this.referreds.length

            return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
}
</script>